import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    editingDocumentRestrictionsC,
    editingDocumentRestrictionsQuota,
} from 'reactApp/appHelpers/featuresHelpers/features/editingDocumentRestrictions';
import { EditorRestrictionsActions } from 'reactApp/modules/editorRestrictions/editorRestrictions.module';
import { EDTIOR_RESTRICTION_SOURCES } from 'reactApp/ui/EditorRestriction/EditorRestriction.const';
import { useUserQuota } from 'reactApp/ui/EditorRestriction/hooks/useUserQuota';
import { ESplashScreenAction } from 'reactApp/ui/Mobile/SplashScreen/SplashScreen.analytics';

export function useHandlers({
    onClose,
    paysource,
    sendAnalytics,
}: {
    onClose?(): void;
    paysource: string;
    sendAnalytics: (arg: ESplashScreenAction) => void;
}) {
    const dispatch = useDispatch();
    const tariffQuotaValue = bytesToNDigits(editingDocumentRestrictionsQuota, 3).value;
    const userQuotaValue = useUserQuota();
    const gbText = editingDocumentRestrictionsC ? 'Добавьте гигабайты за 1 ₽' : 'Добавьте гигабайты';
    const buttonText = editingDocumentRestrictionsC ? `Увеличить место за 1 ₽` : `Увеличить место`;
    const handleClose = useCallback(() => {
        if (paysource === EDTIOR_RESTRICTION_SOURCES.balloon_editor_less_512gb) {
            emitAnalyticEvent(AnalyticEventNames.EDITOR_BALLOON_CLOSE_512);
        }
        if (paysource === EDTIOR_RESTRICTION_SOURCES.touch_editor_less_512gb) {
            emitAnalyticEvent(AnalyticEventNames.EDITOR_SPLASHSCREEN_ALERT_CLOSE_512);
        }
        sendAnalytics(ESplashScreenAction.close);
        onClose?.();
    }, [onClose, paysource]);

    const handleBuyClick = useCallback(() => {
        if (paysource === EDTIOR_RESTRICTION_SOURCES.balloon_editor_less_512gb) {
            emitAnalyticEvent(AnalyticEventNames.EDITOR_BALLOON_CLICK_512);
        }
        if (paysource === EDTIOR_RESTRICTION_SOURCES.touch_editor_less_512gb) {
            emitAnalyticEvent(AnalyticEventNames.EDITOR_SPLASHSCREEN_ALERT_CLICK_512);
        }
        sendAnalytics(ESplashScreenAction.click);
        dispatch(EditorRestrictionsActions.suggestTariff({ paysource }));
        onClose?.();
    }, [onClose, paysource]);

    return { handleBuyClick, handleClose, tariffQuotaValue, userQuotaValue, gbText, buttonText } as const;
}
